import { useTrackers } from '@ps/web-shared-analytics';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CrmZone from '@swf/components/CrmZone/CrmZone';
import { CRMZone } from '@swf/core/enums';
import useOneTrust from '@swf/core/hooks/useOneTrust';
import type { Dispatch, RootState } from '@swf/core/store';
import { select } from '@swf/core/store';

import styles from './FloatingWelcomeOffer.scss';

interface Props {
  popupZoneId?: CRMZone;
  iconZoneId?: CRMZone;
}

const FloatingWelcomeOffer: React.FC<Props> = ({
  popupZoneId = CRMZone.WSL_WELCOME_OFFER_POPUP,
  iconZoneId = CRMZone.WSL_WELCOME_OFFER_ICON
}) => {
  const { alertClosed, oneTrustEnabled } = useOneTrust();
  const { CRMClicked } = useTrackers();
  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const iconContents = useSelector((rootState: RootState) =>
    select.crm.getZone(rootState, iconZoneId)
  );
  const popupContents = useSelector((rootState: RootState) =>
    select.crm.getZone(rootState, popupZoneId)
  );
  const [scrolled, setScrolled] = useState(false);
  const { modal, crm } = useDispatch<Dispatch>();

  const onScroll = useCallback(() => {
    setScrolled(true);
    window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [onScroll]);

  useEffect(() => {
    crm.fetchZone({ zoneId: iconZoneId as string });
    crm.fetchZone({ zoneId: popupZoneId as string });
  }, [crm, isAuthenticated, iconZoneId, popupZoneId]);

  return (alertClosed || !oneTrustEnabled) &&
    !isAuthenticated &&
    iconContents.length &&
    popupContents.length &&
    scrolled ? (
    // eslint-disable-next-line jsx-a11y/interactive-supports-focus
    <div
      className={styles.icon}
      role="button"
      onClick={(event: React.MouseEvent<HTMLDivElement>) => {
        CRMClicked(iconZoneId, iconContents[0], 'open_crm_modal');
        event.preventDefault();
        modal.enqueue({
          path: `/stars-crm/${popupZoneId}`,
          locationState: { zoneId: 'FLOATINGOFFER' }
        });
      }}
    >
      <CrmZone zoneId={iconZoneId} componentType="Single" />
    </div>
  ) : null;
};

export default FloatingWelcomeOffer;
